<template>
  <div :class="['task', 'task-definition-data']">
    <a class="delete" @click="deleteTask()" v-tooltip="{content: getLang('delete'), delay: { show: 300, hide: 100 }}"><i class="sherpa-icon icon-trash"></i></a>
    <definition-obj v-for="reqDef in definition.children" :key="reqDef.id"
      :id="reqDef.id"
      :definitionId="definitionId"
      :reqDef="reqDef"
      :reqObj="getRequestObjectById(reqDef.id)"
      :modeView="type.modeView"
      :languageSelected="languageSelected"
      :definitionContentId="definitionContentId"
      :language="language"
      :visualDefinition="visualDefinition"
      :authorization="authorization"
      :type="type"
      :visuals="visuals"
      :apiparams="apiparams"
      @refreshDefinition="refreshDefinition"
    />
  </div>
</template>

<script>
import language from '../../../language'
import transport from 'vue-definition-utils/src/utils/transport'

export default {
  name: 'definition-builder-task',
  props: [
    'object',
    'definition',
    'language',
    'definitionId',
    'type',
    'languageSelected',
    'definitionContentId',
    'visualDefinition',
    'authorization',
    'visuals',
    'apiparams',
    'sectionIdx',
    'taskIdx'
  ],
  components: {
    DefinitionObj: () => import('../../definitionObj.vue') // Webpack’s asynchronous import for recursivity components
  },
  data () {
    return {
    }
  },
  methods: {
    getLang (key) {
      return language(this.language, key)
    },
    getRequestObjectById (id) {
      return transport.methods.getRequestObjectById(id, this.object.children)
    },
    deleteTask () {
      this.$emit('deleteTask', this.sectionIdx, this.taskIdx)
    },
    refreshDefinition (object) {
      this.$emit('refreshTask', object)
    }
  }
}
</script>

<style lang="scss">
.definition-builder {
  .task {
    background-color: white;
    border: 1px dashed #ffbf28;
    display: inline-block;
    margin-right: 6px;
    margin-bottom: 6px;
    padding: 0px 35px 30px 20px;
    border-radius: 8px;
    border: 1px dashed #6bceda;
    background-color: #f3feff;
    position: relative;
    cursor: all-scroll;
    min-width: 100%;
    min-height: 75px;

    .definition-wrapper {
      padding-top: 0 !important;
    }

    .delete {
      position: absolute;
      top: 7px;
      right: 9px;
      font-size: 18px;
      cursor: pointer;
      color: #ff7643;
      transition: all 0.2s ease-in;

      &:hover {
        color: #ffbd42;
      }
    }

    span.label {
      font-family: Barlow;
      font-size: 13px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.3;
      letter-spacing: normal;
      color: #4599a4;
    }

    .definitionObj {
      .label {
        padding-top: 5px;
        font-size: 13px;
      }
    }

    .languageSelectorOrTask {
      display: none;
    }

    .multiselect__tags {
      padding-top: 1px !important;

      .multiselect__single {
        padding-top: 5px !important;
      }
    }

    .w3-input,
    .multiselect__tags {
      border: 1px dotted #b5b5b5 !important;
      margin-bottom: 0 !important;

      .multiselect__placeholder {
        padding: 5px 0 0px 4px !important;
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/repeatableGroup/definitionBuilder/definitionBuilderTask.vue